import { render, staticRenderFns } from "./UpdateChecker.vue?vue&type=template&id=d2b8a34e&scoped=true"
import script from "./UpdateChecker.vue?vue&type=script&lang=js"
export * from "./UpdateChecker.vue?vue&type=script&lang=js"
import style0 from "./UpdateChecker.vue?vue&type=style&index=0&id=d2b8a34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b8a34e",
  null
  
)

export default component.exports